export default __webpack_public_path__ + "static/media/step_B_UA.8856fe3e.png";